import { ImagePresentationRenderer } from './ImagePresentationRenderer';
import { cancelable } from 'cancelable-promise';
export class PreviewPresentationRender extends ImagePresentationRenderer {
    constructor(assetViewerView, presentation) {
        super(assetViewerView, presentation);
        this.assetViewerView = assetViewerView;
        this.presentation = presentation;
    }
    get width() {
        if (this._width) {
            return this._width;
        }
        if (this.presentation && this.presentation.details && this.presentation.details.dimensions) {
            const exceptions = this.presentation.details.dimensions.exceptions;
            return exceptions && exceptions[this.assetViewerView.page]
                ? exceptions[this.assetViewerView.page].width
                : this.presentation.details.dimensions.width;
        }
    }
    get height() {
        if (this._height) {
            return this._height;
        }
        if (this.presentation && this.presentation.details && this.presentation.details.dimensions) {
            const exceptions = this.presentation.details.dimensions.exceptions;
            return exceptions && exceptions[this.assetViewerView.page]
                ? exceptions[this.assetViewerView.page].height
                : this.presentation.details.dimensions.height;
        }
    }
    set width(value) {
        this._width = value;
    }
    set height(value) {
        this._height = value;
    }
    get url() {
        if (this.presentation && this.presentation.details) {
            const pageIndex = this.presentation.details && this.presentation.details.firstPageIndex === 1
                ? this.assetViewerView.page
                : this.assetViewerView.page - 1;
            const url = this.presentation.urls[pageIndex];
            if (url) {
                return url;
            }
        }
        if (this.assetViewerView.page === 1 || !this.assetViewerView.page) {
            return this.assetViewerView.assetViewerItem.previewUrl;
        }
        return null;
    }
    render(container) {
        if (!this.url) {
            return cancelable(Promise.reject('no preview url'));
        }
        this.container = container;
        this.renderPromise = cancelable(Promise.resolve().then(() => {
            this.image = new Image();
            this.image.src = this.url;
            this.image.style.width = '100%';
            this.image.style.height = '100%';
            if (this.assetViewerView.assetViewerItem.isDownloadable === false) {
                this.image.addEventListener('contextmenu', e => e.preventDefault());
            }
            container.appendChild(this.image);
            // Returning a promises makes the rendering cycle sequential
            return new Promise((resolve, reject) => {
                this.image.onload = () => {
                    this.container.style.background = 'none';
                    this.container.style.backgroundImage = 'none';
                    resolve(this.image);
                };
                this.image.onerror = error => reject(error);
            });
        }));
        return this.renderPromise;
    }
    cancel() {
        if (this.renderPromise) {
            this.renderPromise.cancel();
        }
        if (this.image) {
            this.image.src = '';
            if (this.image.parentNode) {
                this.container.removeChild(this.image);
            }
            this.image.width = 0;
            this.image.height = 0;
            this.image = null;
        }
    }
    destroy() {
        this.cancel();
        if (this.container) {
            this.container.innerHTML = '';
            this.container = null;
        }
        this.image = null;
    }
}
//# sourceMappingURL=PreviewPresentationRenderer.js.map